import { render } from "./RoomBackground.vue?vue&type=template&id=509af42a&ts=true"
import script from "./RoomBackground.vue?vue&type=script&lang=ts"
export * from "./RoomBackground.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__